'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Collection = require('../react/Collection.jsx');

var _Collection2 = _interopRequireDefault(_Collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticCollection = function () {
  function StaticCollection(section) {
    (0, _classCallCheck3.default)(this, StaticCollection);

    this.data = section.data;
    this.root = section.el.querySelector('[data-section-root]');

    this.globalClickTracking = this.globalClickTracking.bind(this);

    this.root.addEventListener('click', this.globalClickTracking);

    _reactDom2.default.render(_react2.default.createElement(_Collection2.default, this.data), this.root);
  }

  (0, _createClass3.default)(StaticCollection, [{
    key: 'globalClickTracking',
    value: function globalClickTracking(e) {
      var heapProperties = {};
      var colorItem = e.target.closest('[data-color-item]');
      var productItem = e.target.closest('[data-product-item]');
      var promoItem = e.target.closest('[data-promo-item]');
      var groupHandle = e.target.closest('[data-group-handle]');
      var promoCta = e.target.closest('.promo-cta');
      if (colorItem) {
        heapProperties.productType = 'thumbnail';
        heapProperties.productHandle = colorItem.dataset.colorItem;
        if (productItem) {
          heapProperties.thumbnailParent = productItem.dataset.productItem;
        }
      } else if (promoItem) {
        heapProperties.productType = 'lifestyle block';
        heapProperties.productHandle = promoItem.dataset.promoItem;
      } else if (productItem) {
        heapProperties.productType = 'product card';
        heapProperties.productHandle = productItem.dataset.productItem;
      } else if (promoCta) {
        heapProperties.productType = 'shop all link';
        var link = e.target.closest('a');
        if (link) {
          var targetPath = link.pathname;
          if (targetPath.startsWith('/collections/')) {
            var collectionHandle = targetPath.replace('/collections/', '');
            heapProperties.productHandle = 'collection-link:' + collectionHandle;
          }
        }
      }
      if (!heapProperties.productType) {
        return;
      }
      if (groupHandle) {
        heapProperties.groupHandle = groupHandle.dataset.groupHandle;
      }
      heapProperties.collectionHandle = this.data.collection.handle;
      if (e.target.closest('.related-collection')) {
        heapProperties.collectionType = 'related';
      } else {
        heapProperties.collectionType = 'main';
      }
      window.heap && window.heap.track('CollectionProductClick', heapProperties);
    }
  }, {
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      _reactDom2.default.unmountComponentAtNode(this.root);
    }
  }]);
  return StaticCollection;
}();

exports.default = StaticCollection;